(function(){
var COL={"Amazonas":["Leticia"],"Antioquia":["Medellin","Envigado","Itagui","Bello","Rionegro"],"Arauca":["Arauca"],"Atlantico":["Barranquilla","Soledad"],"Bolivar":["Cartagena","Magangue"],"Boyaca":["Tunja","Duitama","Sogamoso"],"Caldas":["Manizales"],"Caqueta":["Florencia"],"Casanare":["Yopal"],"Cauca":["Popayan"],"Cesar":["Valledupar"],"Choco":["Quibdo"],"Cordoba":["Monteria"],"Cundinamarca":["Bogota D.C.","Soacha","Girardot","Zipaquira"],"Guainia":["Inirida"],"Guaviare":["San Jose del Guaviare"],"Huila":["Neiva"],"La Guajira":["Riohacha"],"Magdalena":["Santa Marta"],"Meta":["Villavicencio"],"Narino":["Pasto","Ipiales"],"Norte de Santander":["Cucuta"],"Putumayo":["Mocoa"],"Quindio":["Armenia"],"Risaralda":["Pereira","Dosquebradas"],"San Andres y Providencia":["San Andres"],"Santander":["Bucaramanga","Floridablanca","Barrancabermeja"],"Sucre":["Sincelejo"],"Tolima":["Ibague"],"Valle del Cauca":["Cali","Buenaventura","Palmira","Tulua"],"Vaupes":["Mitu"],"Vichada":["Puerto Carreno"]};
var TRM_VAL='cs_trm_v4',TRM_DATE='cs_trm_d4',TRM_SRC='cs_trm_s4';
var TRM=3700,mode='cas',lastCalc=null;
var BASE_COP=74900,LB_USD=2.2;
function baseUSD(){return BASE_COP/TRM;}
var COM_LB=6.5,COM_MIN_LB=5,COM_MAX_UNITS=6,COM_MAX_USD=200;
// Celular, computador y tablet cobran por unidad, no piden peso y NO pasan a comercial.
// Todo lo demas (ropa, tenis, gorras, accesorios, perfumeria, vitaminas,
// electrodomesticos, repuestos, hogar, tecnologia, otros) usa la misma tarifa.
var COM_EXENTAS=['cellphone','computer','tablet'];
// Unicas categorias con seguro del 4%. Ninguna otra lo lleva, asi supere USD 200.
var CON_SEGURO=['computer','tablet','tech'];
function esComercial(pt,val,units){return pt&&COM_EXENTAS.indexOf(pt)===-1&&(val>COM_MAX_USD||units>COM_MAX_UNITS);}
function motivoComercial(val,units){
  if(val>COM_MAX_USD&&units>COM_MAX_UNITS)return 'valor >$200 y mas de 6 unidades';
  if(val>COM_MAX_USD)return 'valor >$200';
  return 'mas de 6 unidades';
}
function fleteComercial(weight,val,units,rows){
  var uw=Math.max(weight,COM_MIN_LB);
  var ship=uw*COM_LB;
  rows.push(['Flete comercial ('+motivoComercial(val,units)+'): '+uw+' lbs x $'+COM_LB.toFixed(2)+(uw>weight?' min '+COM_MIN_LB+' lbs':''),'$'+ship.toFixed(2)+' USD']);
  return ship;
}
function lsGet(k){
  try{return localStorage.getItem(k);}catch(e){return null;}
}
function lsSet(k,v){
  try{localStorage.setItem(k,v);}catch(e){ }
}
function todayKey(){var d=new Date();return d.getFullYear()+'-'+(d.getMonth()+1)+'-'+d.getDate();}
function stale(){return lsGet(TRM_DATE)!==todayKey();}
// TRM en tiempo real con doble fuente:
// 1) TRM oficial de la Superfinanciera via datos.gov.co (a veces se atrasa).
// 2) Si esta vieja o falla, tasa de mercado USD/COP de open.er-api.com (se actualiza a diario).
function fetchTRM(cb){
  var url='https://www.datos.gov.co/resource/32sa-8pi3.json?$limit=1&$order=vigenciadesde%20DESC';
  var fallback=function(){
    try{
      fetch('https://open.er-api.com/v6/latest/USD').then(function(r){return r.json();}).then(function(d){
        var v=d&&d.rates?parseFloat(d.rates.COP):NaN;
        if(v>1000&&v<20000)cb(v,'mercado');else cb(null,null);
      }).catch(function(){cb(null,null);});
    }catch(e){cb(null,null);}
  };
  try{
    fetch(url).then(function(r){return r.json();}).then(function(d){
      var rec=d&&d[0];
      var v=rec?parseFloat(rec.valor):NaN;
      var fresh=false;
      if(rec&&rec.vigenciahasta){
        var age=(new Date().getTime()-new Date(rec.vigenciahasta).getTime())/86400000;
        fresh=age<10;
      }
      if(v>1000&&v<20000&&fresh)cb(v,'oficial');else fallback();
    }).catch(fallback);
  }catch(e){fallback();}
}
function trmLabel(src){
  if(src==='oficial')return 'TRM $'+Math.round(TRM).toLocaleString('es-CO')+' COP/USD - oficial hoy';
  if(src==='mercado')return 'TRM $'+Math.round(TRM).toLocaleString('es-CO')+' COP/USD - tasa de hoy';
  return 'TRM $'+Math.round(TRM).toLocaleString('es-CO')+' COP/USD';
}
function loadTRM(){
  var dot=document.getElementById('trmDot');
  var txt=document.getElementById('trmTxt');
  var sv=parseFloat(lsGet(TRM_VAL)||'0');
  var ss=lsGet(TRM_SRC);
  if(!stale()&&sv>1000){
    TRM=sv;
    dot.classList.add('live');
    txt.textContent=trmLabel(ss);
    return;
  }
  txt.textContent='Actualizando TRM...';
  fetchTRM(function(f,src){
    if(f){
      TRM=f;
      lsSet(TRM_VAL,f);
      lsSet(TRM_DATE,todayKey());
      lsSet(TRM_SRC,src);
      dot.classList.add('live');
      txt.textContent=trmLabel(src);
    }else if(sv>1000){
      TRM=sv;
      dot.classList.add('live');
      txt.textContent=trmLabel(ss)+' - cache';
    }else{
      txt.textContent='TRM $3.700 COP/USD - referencia';
    }
  });
}
function initDepts(){
  var s=document.getElementById('fDept');
  var keys=Object.keys(COL).sort();
  for(var i=0;i<keys.length;i++){
    var o=document.createElement('option');
    o.value=keys[i];
    o.textContent=keys[i];
    s.appendChild(o);
  }
}
window.csOnDeptChange=function(){
  var dept=document.getElementById('fDept').value;
  var cs=document.getElementById('fCity');
  cs.innerHTML='<option value="">Selecciona ciudad</option>';
  if(dept&&COL[dept]){
    cs.disabled=false;
    var cities=COL[dept].slice().sort();
    for(var i=0;i<cities.length;i++){
      var o=document.createElement('option');
      o.value=cities[i];
      o.textContent=cities[i];
      cs.appendChild(o);
    }
  }else{
    cs.disabled=true;
  }
  updateProgress();
};
window.csSetMode=function(m){
  mode=m;
  document.getElementById('btnPS').classList.toggle('on',m==='ps');
  document.getElementById('btnCas').classList.toggle('on',m==='cas');
  var db=document.getElementById('descBar');
  var svg='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>';
  if(m==='cas'){
    db.innerHTML=svg+'<span>En <strong>Casillero</strong> solo pagas el envio por el peso de tus paquetes.</span>';
  }else{
    db.innerHTML=svg+'<span>En <strong>Personal Shopper</strong> nos encargamos de comprar por ti desde cualquier tienda. El valor declarado debe incluir los <strong>taxes de USA</strong>.</span>';
  }
  var valInput=document.getElementById('fVal');
  valInput.placeholder=m==='ps'?'Valor declarado (con taxes USA)':'Valor declarado';
  document.getElementById('infoPS').style.display=m==='ps'?'flex':'none';
  refreshWeight();
};
window.csSelectProd=function(el){
  var cards=document.querySelectorAll('.cs-prod-card');
  for(var i=0;i<cards.length;i++)cards[i].classList.remove('on');
  el.classList.add('on');
  document.getElementById('fProd').value=el.dataset.prod;
  onProdChange();
  updateProgress();
};
function onProdChange(){
  var pt=document.getElementById('fProd').value;
  document.getElementById('condComp').style.display=pt==='computer'?'block':'none';
  document.getElementById('condCell').style.display=pt==='cellphone'?'block':'none';
  refreshWeight();
}
function refreshWeight(){
  var pt=document.getElementById('fProd').value;
  // Solo celular, computador y tablet cobran por unidad y no piden peso.
  var hide=COM_EXENTAS.indexOf(pt)>-1;
  var ww=document.getElementById('wrapWeight');
  ww.style.opacity=hide?'0.35':'1';
  ww.style.pointerEvents=hide?'none':'auto';
  document.getElementById('fWeight').disabled=hide;
  if(hide)document.getElementById('fWeight').value='';
}
function updateProgress(){
  var fields=['fVal','fProd','fUnits','fDept','fCity'];
  var filled=0;
  for(var i=0;i<fields.length;i++){
    var v=document.getElementById(fields[i]).value;
    if(v&&String(v).trim()!=='')filled++;
  }
  var pct=(filled/fields.length)*100;
  document.getElementById('progressBar').style.width=pct+'%';

  var icb=document.getElementById('infoComercial');
  if(icb){
    var vC=parseFloat(document.getElementById('fVal').value)||0;
    var uC=parseInt(document.getElementById('fUnits').value)||0;
    icb.style.display=esComercial(document.getElementById('fProd').value,vC,uC)?'flex':'none';
  }

  var vIds=[['fVal','fldVal'],['fUnits','fldUnits']];
  for(var j=0;j<vIds.length;j++){
    var el=document.getElementById(vIds[j][0]);
    var f=document.getElementById(vIds[j][1]);
    if(f){
      if(el.value&&parseFloat(el.value)>0)f.classList.add('valid');
      else f.classList.remove('valid');
    }
  }
}
function psFee(v){return v<=300?v*0.12:v<=600?v*0.08:v*0.06;}
function fU(n){return '$'+n.toFixed(2)+' USD';}
function fC(n){return '$'+Math.round(n).toLocaleString('es-CO')+' COP';}
function computeCost(customMode){
  var activeMode=customMode||mode;
  var val=parseFloat(document.getElementById('fVal').value)||0;
  var weight=parseFloat(document.getElementById('fWeight').value)||0;
  var units=parseInt(document.getElementById('fUnits').value)||0;
  var pt=document.getElementById('fProd').value;

  var ship=0,ins=0,fee=0,prodCost=0;
  var rows=[];

  if(activeMode==='ps'){
    prodCost=val;
    rows.push(['Costo del producto (incluye taxes USA)',fU(val)]);
  }

  if(pt==='cellphone'){
    var isNewCell=document.querySelector('input[name="cellC"]:checked');
    var isNew=isNewCell&&isNewCell.value==='new';
    if(isNew){
      ship=75*units;
      rows.push(['Flete celular (nuevo/caja)',fU(ship)]);
    }else{
      var rate=units>=10?40:units>=5?45:55;
      ship=rate*units;
      rows.push(['Flete celular usado ('+units+' x $'+rate+')',fU(ship)]);
    }
  }else if(pt==='computer'){
    if(val>=1000)return{error:'Para computadores con valor mayor a $1.000 USD contactanos para cotizacion especial.'};
    var condEl=document.querySelector('input[name="compC"]:checked');
    var cond=condEl?condEl.value:'new';
    var base=cond==='new'?75:cond==='used_box'?65:55;
    var cl=cond==='new'?'nuevo':cond==='used_box'?'usado con caja':'usado sin caja';
    ship=base*units;
    rows.push(['Flete computador '+cl+' ('+units+' x $'+base+')',fU(ship)]);
  }else if(pt==='tablet'){
    ship=45*units;
    rows.push(['Flete tablet/iPad ('+units+' x $45)',fU(ship)]);
  }else{
    // Misma tarifa para todas las demas categorias, tecnologia incluida.
    if(esComercial(pt,val,units)){
      ship=fleteComercial(weight,val,units,rows);
    }else{
      var wc2=weight*LB_USD;
      ship=baseUSD()+wc2;
      rows.push(['Cargo fijo de servicio (valor <=$200)',fC(BASE_COP)]);
      rows.push(['Libras: '+weight+' lbs x $'+LB_USD.toFixed(2)+' USD',fU(wc2)]);
    }
  }
  // Seguro del 4%: SOLO computador, tablet y tecnologia.
  if(CON_SEGURO.indexOf(pt)>-1){
    ins=val*0.04;
    rows.push(['Seguro obligatorio 4%',fU(ins)]);
  }
  if(activeMode==='ps'){
    fee=psFee(val);
    var pct=val<=300?12:val<=600?8:6;
    rows.push(['Comision Personal Shopper '+pct+'%',fU(fee)]);
  }
  return{total:prodCost+ship+ins+fee,rows:rows,ship:ship,ins:ins,fee:fee,prodCost:prodCost,warn:val>200};
}
function animateNumber(el,start,end,duration,formatter){
  // Fallback inmediato: si la pestana esta oculta requestAnimationFrame no corre
  // y el contador se quedaba en cero.
  el.textContent=formatter(end);
  var startTime=performance.now();
  function step(now){
    var elapsed=now-startTime;
    var progress=Math.min(elapsed/duration,1);
    var eased=1-Math.pow(1-progress,3);
    el.textContent=formatter(start+(end-start)*eased);
    if(progress<1)requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
window.csCalc=function(){
  var val=parseFloat(document.getElementById('fVal').value)||0;
  var units=parseInt(document.getElementById('fUnits').value)||0;
  var weight=parseFloat(document.getElementById('fWeight').value)||0;
  var pt=document.getElementById('fProd').value;
  var dept=document.getElementById('fDept').value;
  var city=document.getElementById('fCity').value;
  var dest=city&&dept?city+', '+dept:'No especificado';
  var box=document.getElementById('resultBox');
  var needW=COM_EXENTAS.indexOf(pt)===-1;
  var err='';
  if(val<=0)err='Ingresa el valor declarado en USD.';
  else if(!pt)err='Selecciona el tipo de producto.';
  else if(units<=0)err='Ingresa el numero de unidades.';
  else if(needW&&weight<=0)err='Ingresa el peso del paquete en libras.';
  if(err){
    box.style.display='block';
    box.className='cs-result err';
    box.innerHTML='<strong>Datos incompletos:</strong> '+err;
    return;
  }
  var result=computeCost();
  if(result.error){
    box.style.display='block';
    box.className='cs-result err';
    box.innerHTML=result.error;
    return;
  }
  var total=result.total;
  var rows=result.rows;
  var totalCOP=total*TRM;
  var prodEl=document.querySelector('.cs-prod-card.on .plbl');
  var prodLabel=prodEl?prodEl.textContent:'';
  lastCalc={val:val,units:units,weight:weight,pt:pt,dept:dept,city:city,dest:dest,total:total,totalCOP:totalCOP,rows:rows,prodLabel:prodLabel,prodCost:result.prodCost,warn:result.warn};
  var modeName=mode==='cas'?'Casillero':'Personal Shopper';
  var waWarn=result.warn?'\n\n*Nota: los precios de compras mayores a $200 USD varian constantemente. Cotizacion aproximada.':'';
  var waMsg=encodeURIComponent('Hola Celada Shopper!\n\nCotizacion calculada:\nModalidad: '+modeName+'\nProducto: '+prodLabel+'\nUnidades: '+units+'\nValor declarado: '+fU(val)+'\nDestino: '+dest+'\n\nTotal estimado: '+fU(total)+'\nEn pesos: '+fC(totalCOP)+waWarn+'\n\nQuedo en espera, gracias!');
  var bkRows='';
  for(var i=0;i<rows.length;i++){
    bkRows+='<div class="cs-bk-row"><span class="cs-bk-row-lbl"><span class="cs-bk-row-dot"></span>'+rows[i][0]+'</span><span class="cs-bk-row-val">'+rows[i][1]+'</span></div>';
  }
  var compareLabel=mode==='cas'?'Personal Shopper':'Casillero';
  var trmFmt=Math.round(TRM).toLocaleString('es-CO');
  var html='<div class="cs-result-hero">'+
    '<div class="cs-rcard"><p class="cs-rcard-lbl">Total estimado</p><p class="cs-rcard-val gold" id="animTotalUSD">$0.00 USD</p></div>'+
    '<div class="cs-rcard"><p class="cs-rcard-lbl">En pesos colombianos</p><p class="cs-rcard-val mint" id="animTotalCOP">$0 COP</p><p class="cs-rcard-sub">TRM $'+trmFmt+' COP/USD</p></div>'+
    '</div>'+
    '<div class="cs-bk">'+
    (result.warn?'<div class="cs-warnbox"><span style="font-size:15px;flex-shrink:0">⚠️</span><div><strong>Importante:</strong> los precios de compras mayores a $200 USD varian constantemente. Esta cotizacion es aproximada y puede cambiar al momento de la compra.</div></div>':'')+
    '<div class="cs-bk-header">'+
    '<span class="cs-bk-lbl">Desglose del calculo</span>'+
    '<button type="button" class="cs-btn-copy" id="btnCopy" onclick="csCopyBreakdown()">'+
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>Copiar'+
    '</button></div>'+
    '<div>'+bkRows+'</div>'+
    '<p class="cs-meta"><strong>'+units+' unid.</strong> &middot; '+prodLabel+' &middot; Valor: '+fU(val)+' &middot; Destino: '+dest+'</p>'+
    '<button type="button" class="cs-compare" onclick="csShowComparison()">'+
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 3H5a2 2 0 00-2 2v14a2 2 0 002 2h3M16 3h3a2 2 0 012 2v14a2 2 0 01-2 2h-3M12 3v18"/></svg>'+
    'Comparar con '+compareLabel+'</button>'+
    '<div id="comparisonBox"></div>'+
    '<a class="cs-wa" href="https://wa.me/573001260097?text='+waMsg+'" target="_blank" rel="noopener">'+
    '<svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2C6.477 2 2 6.477 2 12c0 1.488.375 2.906 1.034 4.167L2 22l5.833-1.034A9.953 9.953 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm4.848 11.924c-.111-.06-.727-.362-.84-.404-.112-.042-.194-.064-.276.064-.082.127-.317.404-.388.486-.07.082-.143.092-.266.03-.122-.061-.515-.189-.982-.605-.363-.317-.607-.71-.679-.836-.07-.127-.008-.195.056-.255.056-.05 1-.413 1-.994s-.5-.916-.563-.998c-.063-.082-.136-.062-.208-.062h-.266c-.07.03-.276.064-.42.213-.142.149-.545.534-.545 1.282 0 .748.558 1.487.63 1.597.07.11 1.077 1.644 2.59 2.278.373.15.666.242.894.312.336.103.64.088.883.053.276-.04.727-.297.83-.585.102-.289.102-.538.071-.587-.031-.049-.112-.081-.235-.148z"/></svg>'+
    'Continuar por WhatsApp</a></div>';
  box.style.display='block';
  box.className='cs-result ok';
  box.innerHTML=html;
  setTimeout(function(){
    animateNumber(document.getElementById('animTotalUSD'),0,total,800,function(v){return fU(v);});
    animateNumber(document.getElementById('animTotalCOP'),0,totalCOP,800,function(v){return fC(v);});
  },100);
  box.scrollIntoView({behavior:'smooth',block:'nearest'});
};
window.csShowComparison=function(){
  if(!lastCalc)return;
  var otherMode=mode==='cas'?'ps':'cas';
  var otherResult=computeCost(otherMode);
  if(otherResult.error)return;

  var curService=lastCalc.total-(lastCalc.prodCost||0);
  var otherService=otherResult.total-(otherResult.prodCost||0);
  var diff=otherService-curService;
  var isSaving=diff>0;
  var otherLabel=otherMode==='cas'?'Casillero':'Personal Shopper';
  var currentLabel=mode==='cas'?'Casillero':'Personal Shopper';
  var diffColor=isSaving?'var(--success)':'#fb923c';
  var diffIcon=isSaving?'Ahorras':'Pagas mas';

  var html='<div class="cs-comparison">'+
    '<div class="cs-comparison-row"><span style="color:var(--text-muted)">Con <strong style="color:var(--gold)">'+currentLabel+'</strong> (actual)</span><strong>'+fU(curService)+'</strong></div>'+
    '<div class="cs-comparison-row"><span style="color:var(--text-muted)">Con <strong>'+otherLabel+'</strong></span><strong>'+fU(otherService)+'</strong></div>'+
    '<div class="cs-comparison-row" style="border-top:1px solid var(--border);padding-top:10px;margin-top:4px"><span style="color:var(--text-muted)">'+diffIcon+' con '+currentLabel+':</span><span class="cs-saving" style="color:'+diffColor+'">'+fU(Math.abs(diff))+'</span></div>'+
    '<p style="font-size:11px;color:var(--text-hint);margin-top:8px">Comparacion del costo del servicio, sin incluir el valor del producto.</p>'+
    '</div>';

  document.getElementById('comparisonBox').innerHTML=html;
};
window.csCopyBreakdown=function(){
  if(!lastCalc)return;
  var modeLabel=mode==='cas'?'Casillero':'Personal Shopper';
  var rowsText='';
  for(var i=0;i<lastCalc.rows.length;i++){
    rowsText+='- '+lastCalc.rows[i][0]+': '+lastCalc.rows[i][1]+'\n';
  }
  var trmFmt=Math.round(TRM).toLocaleString('es-CO');
  var text='COTIZACION CELADA SHOPPER\n'+
    'Modalidad: '+modeLabel+'\n'+
    'Producto: '+lastCalc.prodLabel+'\n'+
    'Unidades: '+lastCalc.units+'\n'+
    'Valor declarado: '+fU(lastCalc.val)+'\n'+
    'Destino: '+lastCalc.dest+'\n\n'+
    'DESGLOSE:\n'+rowsText+'\n'+
    'TOTAL: '+fU(lastCalc.total)+'\n'+
    'EN PESOS: '+fC(lastCalc.totalCOP)+'\n'+
    'TRM: $'+trmFmt+' COP/USD'+
    (lastCalc.warn?'\n\nNOTA: los precios de compras mayores a $200 USD varian constantemente. Cotizacion aproximada.':'');

  navigator.clipboard.writeText(text).then(function(){
    var btn=document.getElementById('btnCopy');
    btn.classList.add('copied');
    btn.innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>Copiado!';
    setTimeout(function(){
      btn.classList.remove('copied');
      btn.innerHTML='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>Copiar';
    },2000);
  });
};
window.csResetAll=function(){
  var ids=['fVal','fWeight','fUnits'];
  for(var i=0;i<ids.length;i++)document.getElementById(ids[i]).value='';
  document.getElementById('fProd').value='';
  var cards=document.querySelectorAll('.cs-prod-card');
  for(var j=0;j<cards.length;j++)cards[j].classList.remove('on');
  document.getElementById('fDept').selectedIndex=0;
  document.getElementById('fCity').innerHTML='<option value="">Selecciona ciudad</option>';
  document.getElementById('fCity').disabled=true;
  document.getElementById('fSpeed').selectedIndex=0;
  var rn=document.querySelector('input[name="compC"][value="new"]');
  if(rn)rn.checked=true;
  var ru=document.querySelector('input[name="cellC"][value="used"]');
  if(ru)ru.checked=true;
  var hideIds=['condComp','condCell','infoComercial'];
  for(var k=0;k<hideIds.length;k++)document.getElementById(hideIds[k]).style.display='none';
  document.getElementById('infoPS').style.display=mode==='ps'?'flex':'none';
  document.getElementById('resultBox').style.display='none';
  var validFields=document.querySelectorAll('.cs-field.valid');
  for(var m=0;m<validFields.length;m++)validFields[m].classList.remove('valid');
  lastCalc=null;
  refreshWeight();
  updateProgress();
};
initDepts();
loadTRM();
var listenIds=['fVal','fUnits','fWeight','fCity'];
for(var z=0;z<listenIds.length;z++){
  var elL=document.getElementById(listenIds[z]);
  if(elL){
    elL.addEventListener('input',updateProgress);
    elL.addEventListener('change',updateProgress);
  }
}
})();
